export type ThemeMode = 'system' | 'light' | 'dark';

const THEME_STORAGE_KEY = 'winsight.theme';

/** The saved override, or System when the user has not chosen one. */
export function readThemeMode(): ThemeMode {
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    return saved === 'light' || saved === 'dark' ? saved : 'system';
  } catch {
    return 'system';
  }
}

/** Save and immediately apply a theme choice. System is represented by no stored override. */
export function applyThemeMode(mode: ThemeMode): void {
  try {
    if (mode === 'system') {
      window.localStorage.removeItem(THEME_STORAGE_KEY);
    } else {
      window.localStorage.setItem(THEME_STORAGE_KEY, mode);
    }
  } catch {
    // A locked-down browser may reject storage; the choice still applies for this page load.
  }

  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  document.documentElement.classList.toggle('light', mode === 'light');
  document.documentElement.classList.toggle(
    'dark',
    mode === 'dark' || (mode === 'system' && prefersDark),
  );
}
